import { createAsyncAction } from 'typesafe-actions';
import { App } from './types';

export const fetchApp = createAsyncAction(
  'app/FETCH_REQUEST',
  'app/FETCH_SUCCESS',
  'app/FETCH_FAILURE'
)<void, App[], Error>();

export const checkApp = () => {
  return (dispatch: any) => {
    return dispatch(async (dispatch: any) => {
      
      dispatch(fetchApp.request());
      // const url = 'https://d11qmvs9m8e4cw.cloudfront.net/version.json';
      const url = 'https://npp-assets.s3.amazonaws.com/version.json';
      return fetch(url)
        .then(response => {
          return response.json()
        })
        .then((json) => {
          dispatch(fetchApp.success(json));
        });
    });
  }
}